// extracted by mini-css-extract-plugin
export default {"container":"styles_container__L84D3","serviceContainer":"styles_serviceContainer__Z19xc","card":"styles_card__05Ya2","installationHeader":"styles_installationHeader__XwqmQ"};